interface Props {
  data: Record<string, any>;
}

function RiskField({ label, value }: { label: string; value?: string }) {
  if (!value) return null;
  return (
    <div className="p-3 rounded-lg glass-subtle">
      <p className="text-[11px] text-ink-500 uppercase tracking-wider font-medium mb-1">
        {label}
      </p>
      <p className="text-sm text-ink-200 leading-relaxed">{value}</p>
    </div>
  );
}

export default function RiskAssessment({ data }: Props) {
  return (
    <div className="space-y-4">
      {data.summary && (
        <p className="text-sm text-ink-300 leading-relaxed border-l-2 border-accent-400 pl-3">
          {data.summary}
        </p>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <RiskField label="Saúde Financeira" value={data.financial_health} />
        <RiskField label="Ratings de Crédito" value={data.credit_ratings} />
        <RiskField label="Riscos Operacionais" value={data.operational_risks} />
        <RiskField label="Histórico de Conformidade" value={data.compliance_history} />
        <RiskField label="Histórico de Litígios" value={data.litigation_history} />
        <RiskField label="Riscos ESG" value={data.esg_risks} />
      </div>
    </div>
  );
}
